import { render, staticRenderFns } from "./LoadingButtonOrange.vue?vue&type=template&id=7137009b"
import script from "./LoadingButtonOrange.vue?vue&type=script&lang=js"
export * from "./LoadingButtonOrange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports